import Mustache from 'mustache';

/**
 * Renders a Mustache template with the given data.
 * @param {string} template - The mustache template string.
 * @param {object} view - The data object with values to inject into the template.
 * @returns {string} The rendered string.
 */
export function renderPrompt(template, view) {
  // Disables HTML escaping to render text as-is
  Mustache.escape = text => text;
  return Mustache.render(template, view);
}
